// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"06ce1c85","186":"bbc065af","453":"e1af1b6e","531":"232089bc","625":"72641edd","649":"574700ac","652":"6a7816b4","674":"7c3b6589","900":"0563cc60"}[chunkId] + ".chunk.js";
};